import React from 'react';
import Modal from '../ui/modal';
import { bindActionCreators } from 'redux';
import { setGlobalErrorVisibility } from '../../redux/action';
import { connect } from 'react-redux';
import ErrorModal from '../error-modal';

/**
 * Global server error controlled from redux
 * @param {*} param0 props
 */
function ServerErrorModal({ visible, setGlobalErrorVisibility }) {
  return (
    <Modal
      isOpened={visible}
      onClose={() => setGlobalErrorVisibility(false)}
      closeOnDocumentClick
      withCross
      className="special"
    >
      <ErrorModal headlineText="error_modal_title" />
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  visible: state.app.globalErrorVisible,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setGlobalErrorVisibility,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ServerErrorModal);
